module.exports = __webpack_public_path__ + "img/title.6bf1bad0.png";